import {useEffect, useState} from 'react';
import LayoutComponent from "../components/LayoutComponent";
import TableComponent from "../components/TableComponent";
import {useApi} from "../provider/ApiProvider";
import UserDialog from "../dialogs/UserDialog";
import {Badge, Button, Popconfirm} from 'antd';
import {
    DeleteOutlined,
    DownloadOutlined,
    EditFilled,
    FileExcelOutlined,
    PlusOutlined,
    RightOutlined
} from "@ant-design/icons";

import { Excel } from 'antd-table-saveas-excel';
export default function UsersPage(){

    const columns = [

        {
            title: 'Adı',
            dataIndex: 'firstName',
            key: 'firstName',
        },
        {
            title: 'Soyadı',
            dataIndex: 'lastName',
            key: 'lastName',
        },
        {
            title: 'TC',
            dataIndex: 'identityNumber',
            key: 'identityNumber',

        },
        {
            title: 'Telefon',
            dataIndex: 'phone',
            key: 'phone',
            responsive: ["lg"]
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            responsive: ["lg"]
        },

        {
            title: 'Firma / Şube',
            render: (record) => record.Company.name
        },

        {
            title: 'Durumu',
            responsive: ["lg"],
            render: (record) => record.isActive ? <Badge status="success" text={"Aktif"} /> : <Badge status="error" text={"Pasif"} />

        },
        {
            title: 'Yemek',
            render: (record) => record.ticketCount
        },

        {
            title: 'İşlemler',
            fixed: 'right',
            width: 220,
            render: (record) => (
                <div>
                    <Popconfirm
                        title="Silmek istediğinize emin misiniz?"
                        onConfirm={() => {deleteRow(record.id)}}
                        onCancel={() => {
                            return;
                        }}
                        okText="Evet"
                        cancelText="Hayır"
                    >
                        <Button  danger>
                            <DeleteOutlined/>
                        </Button>
                    </Popconfirm>
                    <Button style={{marginLeft: '4%'}} onClick={() => editDialog(record)}>
                        <EditFilled/>
                    </Button>
                    <Button style={{marginLeft: '4%'}} onClick={() => ticketDialog(record)}>
                        <DownloadOutlined />
                    </Button>
                </div>
            )
        }

    ];
    const columnsexcel = [

        {
            title: 'Adı',
            dataIndex: 'firstName',
            key: 'firstName',
        },
        {
            title: 'Soyadı',
            dataIndex: 'lastName',
            key: 'lastName',
        },
        {
            title: 'TC',
            dataIndex: 'identityNumber',
            key: 'identityNumber',

        },
        {
            title: 'Telefon',
            dataIndex: 'phone',
            key: 'phone',
            responsive: ["lg"]
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            responsive: ["lg"]
        },

        {
            title: 'Firma / Şube',
            dataIndex: ['Company','name'],
            key: 'Firma / Şube',
            responsive: ["lg"]

        },

        {
            title: 'Durumu',
            dataIndex: 'isActive',
            key: 'Durumu',
            responsive: ["lg"],


        },

        {
            title: 'Yemek',
            dataIndex: 'ticketCount',
            key: 'Yemek',
            responsive: ["lg"],


        }
    ];


    const {api} = useApi();
    const [users, setUsers] = useState({totalCount: 0, items: []});
    const [dialog, setDialog] = useState({open: false, data: null});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        load({search: "", skip: 0, max: 10000});
    }, [])

    async function load(filter){
        setLoading(true);
        await api.get('/userRouter/user/all', filter).then(resp => {
            setUsers({totalCount: resp.totalCount, items:resp.data});
        }).finally(() => setLoading(false))
    }

    function addDialog(){
        setDialog({open: true, data: null, type: "user"});
    }

    function editDialog(data){
        setDialog({open: true, data: data, type: "user"});
    }


    function ticketDialog(data){
        setDialog({open: true, data: data, type:'ticket'});
    }

    async function onSearch(value){
        let filter = {
            search: value
        }
        setLoading(true);
        await api.get('/userRouter/user/all', filter).then(resp => {
            setUsers({totalCount: resp.totalCount, items:resp.data});
        }).finally(() => setLoading(false));
    }

    async function deleteRow(id){
        setLoading(true);

        await api.delete('/userRouter/user/delete/' + id).then(resp => {
           load({search: "", skip: 0, max: 10})
        }).finally(() => setLoading(false));
    }

    function tableChange(filter){
        let newFilter = {
            skip: (filter.page - 1) * filter.perPage,
            max: filter.perPage
        }
        load(newFilter);
    }

    return (
        <LayoutComponent title={"Kullanıcılar"} links={
            [
                {
                    title: 'Kullanıcılar',
                    url: ''
                },
            ]
        } newButton={<>
            <div>
            <Button icon={<PlusOutlined />} onClick={() => addDialog()} type="primary" style={{marginRight: '10px'}}>Ekle</Button>



            <Button
                type="primary"
                icon={<FileExcelOutlined />}
                onClick={() => {
                    const excel = new Excel();
                    excel
                        .addSheet('Kullanıcılar')
                        .addColumns(columnsexcel)
                        .addDataSource(users.items)
                        .saveAs('Kullanıcılar.xlsx');
                }}
            >
                Excel
            </Button>
            </div>

        </>}>

            <TableComponent
                columns={columns}
                data={users}
                search={true}
                onSearch={onSearch}
                onChange={tableChange}
                loading={loading}

            />
            <UserDialog
                open={dialog.open}
                data={dialog.data}
                type={dialog.type}
                onChange={() => load()}
                onClose={() => setDialog({open: false, data: null,type:null})}
            />
        </LayoutComponent>
    )
}
